module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ed-input-item', {
    attrs: {
      "label": _vm.label,
      "info": _vm.info,
      "name": _vm.name,
      "required": _vm.required
    }
  }, [_c('p', {
    staticClass: "mt-5"
  }, [_c('ckeditor', {
    attrs: {
      "id": _vm.id,
      "value": _vm.value,
      "config": _vm.editorConfig,
      "disabled": _vm.disabled,
      "read-only": _vm.readonly,
      "tag-name": "textarea",
      "editor-url": _vm.editorUrl
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a69dc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdInputEditor.vue
// module id = 1538
// module chunks = 45